module.exports = __webpack_public_path__ + "img/Logo_pic_yellow.0a3478fb.svg";